import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EmailVerificationView } from "./EmailVerificationView";
import { EmailVerificationViewStore } from "../../store/EmailVerificationViewStore";
import { useStore } from "../../../../hooks";

export const EmailVerificationViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/emailVerification/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EmailVerificationViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EmailVerificationView emailVerificationViewStore={store} />
      </PageLayout>
    </div>
  );
});
